import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { constants, rootStore } from 'cv-react-core';
import Navigator from './Navigator';
import routeNames from './routeNames';
import SettingsPage from '../components/pages/SettingsPage/SettingsPage';

@observer
class SettingsRoute extends Component {
    static propTypes = {
        navigator: PropTypes.instanceOf(Navigator),
    };

    render() {
        const {
                sessionStore,
                settingsStore,
                uiStore,
                } = rootStore;
        const params = {
            getSettings: settingsStore.getSanitizedSettings,
            setSettings: settingsStore.fromSanitizedSettings,
            onLogin: this.handleOnLoginPress,
            uiStore,
            sessionStore,
            settingsStore,
        };

        return (
            <SettingsPage { ...params } />
        );
    }

    handleOnLoginPress = () => {
        const { uiStore } = rootStore;
        uiStore.setValueForUIObject(constants.ui.APPLICATION_UI_ID, constants.ui.LOGIN_IN_PROGRESS, false, false);
        const { navigator } = this.props;
        navigator.history.replace(`/${routeNames.LOGIN}`);
    }
}

export default SettingsRoute;
